import {
  EducationLevelType,
  LegalClientFinancialInstrumentType,
} from 'api/types/entity';
import { GridFields } from 'components';
import { getYesOrNoOptions, isYes } from 'helpers';
import { useTranslation } from 'libs/i18n';

import {
  Field,
  useFormContext,
} from '../../../../forms/knowledgeAndExperienceForm';

export const FormContent = () => {
  const { t } = useTranslation();

  const { values } = useFormContext();

  const isOtherFinancialInstrument =
    values.knowledgeAndExperience?.financialInstruments?.some(
      (v) => v?.value === LegalClientFinancialInstrumentType.Other
    );

  return (
    <GridFields>
      <Field.Autocomplete
        fullWidth
        multiple
        label={t(
          'client.legal.legalKnowledgeAndExperience.financialInstruments.label'
        )}
        name="knowledgeAndExperience.financialInstruments"
        optionLabelKey="label"
        options={Object.values(LegalClientFinancialInstrumentType)?.map(
          (v) => ({
            label: t(
              `client.legal.legalKnowledgeAndExperience.financialInstruments.types.${v}`
            ),
            value: v,
          })
        )}
        optionValueKey="value"
        placeholder={t(
          'client.legal.legalKnowledgeAndExperience.financialInstruments.placeholder'
        )}
      />
      {isOtherFinancialInstrument && (
        <Field.Text
          fullWidth
          showRequiredMark
          label={t(
            'client.legal.legalKnowledgeAndExperience.otherFinancialInstrument.label'
          )}
          name="knowledgeAndExperience.otherFinancialInstrument"
          placeholder={t(
            'client.legal.legalKnowledgeAndExperience.otherFinancialInstrument.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        fullWidth
        showRequiredMark
        label={t(
          'client.legal.legalKnowledgeAndExperience.hasQualifiedOfficersForInvestmentDecisions.label'
        )}
        name="knowledgeAndExperience.hasQualifiedOfficersForInvestmentDecisions"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.chooseAnOption')}
      />

      {isYes(
        values.knowledgeAndExperience
          ?.hasQualifiedOfficersForInvestmentDecisions
      ) && (
        <>
          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.legalKnowledgeAndExperience.educationLevel.label'
            )}
            name="knowledgeAndExperience.educationLevel"
            optionLabelKey="label"
            options={Object.values(EducationLevelType).map((v) => ({
              label: t(
                `client.client.knowledgeAndExperience.education.types.${v}`
              ),
              value: v,
            }))}
            optionValueKey="value"
            placeholder={t('common.chooseAnOption')}
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.legalKnowledgeAndExperience.heldFinancialPositionInLast5Years.label'
            )}
            name="knowledgeAndExperience.heldFinancialPositionInLast5Years"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.chooseAnOption')}
          />
        </>
      )}
    </GridFields>
  );
};
